import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics, scrollTo, convertToPlainText } from '../../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import './AmexPlatinumNightsBenefitsCardRefresh.scss';

let hashTimeout = null;

const AmexPlatinumNightsBenefitsCardRefresh = (
  {
    Analytics,
    awsFolderName,
    baseRequestUrl,
    matchMedia,
    cardConfig: {
      title,
      title_mobile: titleMobile,
      copy,
      logo,
      logo_aria: logoAria = '',
      cta,
    },
    utm,
    index,
    componentCallback,
  }
) => {
  const urlPrefix = `${baseRequestUrl}${awsFolderName}/logos/`;
  const logoPath = `${urlPrefix}${logo}`;
  const hasMobileTitle = typeof titleMobile === 'string' && titleMobile.trim();
  const cardTitle = !matchMedia?.lg && hasMobileTitle ? titleMobile : title;

  useEffect(() => {
    if (hashTimeout) clearTimeout(hashTimeout);
  }, []);

  const sanitizedTitle = sanitizeString(cardTitle);
  const sanitizedCopy = sanitizeString(copy);

  const handleClick = () => {
    const extraParams = {
      action_name: 'Benefits - Learn More Click',
      item_name: convertToPlainText(sanitizedTitle),
    };
    handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraParams);
  };

  const displayCTA = () => {
    const { id, label, url } = cta;
    const ctaUrl = utm ? `${url}${utm}` : url;

    switch (id) {
      case 'platinum':
        return (
          <Link
            href={window?.location?.href?.split('#')[0] + url}
            className="AmexPlatinumNightsBenefitsCardRefresh__cta platinum"
            aria-describedby={`benefitTitle${index}`}
            onContextMenu={handleClick}
            onClick={() => {
              handleClick();
              const currentHash = url.replace('#', '');
              componentCallback('hash', currentHash);
              hashTimeout = setTimeout(() => scrollTo(url), 1000);
            }}
          >
            {label}
          </Link>
        );
      default:
        return (
          <Link
            className="AmexPlatinumNightsBenefitsCardRefresh__cta"
            target="_blank"
            href={ctaUrl}
            aria-describedby={`benefitTitle${index}`}
            onClick={() => {
              handleClick();
            }}
          >
            {label}
          </Link>
        );
    }
  };
  return (
    <div
      className="AmexPlatinumNightsBenefitsCardRefresh"
      role="group"
      aria-labelledby={`benefitTitle${index}`}
    >
      <div className="AmexPlatinumNightsBenefitsCardRefresh__logo--wrapper">
        {logo && (
          <img className="AmexPlatinumNightsBenefitsCardRefresh__logo" src={logoPath} alt={logoAria} />
        )}
      </div>
      <div className="AmexPlatinumNightsBenefitsCardRefresh__content">
        {cardTitle && (
          <h3
            id={`benefitTitle${index}`}
            className="AmexPlatinumNightsBenefitsCardRefresh__title"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
        )}
        {copy && (
          <p
            className="AmexPlatinumNightsBenefitsCardRefresh__copy"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedCopy,
            }}
          />
        )}
      </div>
      {displayCTA()}
    </div>
  );
};

export default AmexPlatinumNightsBenefitsCardRefresh;

AmexPlatinumNightsBenefitsCardRefresh.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  cardConfig: PropTypes.shape({
    title: PropTypes.string.isRequired,
    title_mobile: PropTypes.string,
    copy: PropTypes.string.isRequired,
    logo: PropTypes.string,
    logo_aria: PropTypes.string,
    cta: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  utm: PropTypes.string,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }),
  index: PropTypes.number.isRequired,
  componentCallback: PropTypes.func,
};

AmexPlatinumNightsBenefitsCardRefresh.defaultProps = {
  utm: null,
  matchMedia: null,
  componentCallback: () => {},
};
